import React from 'react';
import PropTypes from 'prop-types';

import { every, some } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip } from '@fortawesome/pro-solid-svg-icons';

import FilesRow from './files_row';

export default function FilesTable({ files, selectedIds, onSelectedChange }) {
  const isSelected = fileId => selectedIds.includes(fileId);
  const someSelected = () => some(files, file => isSelected(file.id)) && selectedIds.length > 0;
  const allSelected = () => every(files, file => isSelected(file.id)) && selectedIds.length > 0;

  const handleSelect = (fileId) => {
    const newSelectedIds = isSelected(fileId) ? selectedIds.filter(id => id !== fileId) : [...selectedIds, fileId];
    onSelectedChange(newSelectedIds);
  };

  const handleSelectAll = () => {
    onSelectedChange(someSelected() ? [] : files.map(file => file.id));
  };

  return (
    <div className="table-responsive">
      <table className="table border-clear m-0">
        <thead>
          <tr>
            <th className="auto-size">
              <input
                checked={allSelected()}
                className="checkbox--lg"
                ref={input => input && (input.indeterminate = someSelected() && !allSelected())}
                type="checkbox"
                onChange={handleSelectAll}
              />
            </th>
            <th className="auto-size">
              <FontAwesomeIcon className="text-muted" icon={faPaperclip} />
            </th>
            <th>File Name</th>
            <th>File Type</th>
          </tr>
        </thead>

        <tbody>
          {
            files.map(file => (
              <FilesRow
                file={file}
                key={file.id}
                selected={isSelected(file.id)}
                onSelected={handleSelect}
              />
            ))
          }
        </tbody>
      </table>
    </div>
  );
}

FilesTable.propTypes = {
  files: PropTypes.array.isRequired,
  selectedIds: PropTypes.array.isRequired,
  onSelectedChange: PropTypes.func.isRequired
};
